import React from 'react';
import Loader from 'src/components/loader';
import loadable from '@loadable/component';

import brandPageQuery from './query.graphql';

const BrandPage = loadable(
  () => import(/* webpackChunkName: "brand" */ './components'),
  {
    fallback: <Loader />,
  }
);

BrandPage.variables = ({ id }) => ({ id });

BrandPage.graphQL = brandPageQuery;

BrandPage.loadOrder = [{}];

export default BrandPage;
